var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "party" }, [
    _c("div", { staticClass: "party-name" }, [_vm._v(_vm._s(_vm.party.Name))]),
    _c("div", [
      _vm._v(_vm._s(_vm.party.Street) + " " + _vm._s(_vm.party.StreetNumber)),
    ]),
    _c("div", [
      _vm._v(_vm._s(_vm.party.Zipcode) + " " + _vm._s(_vm.party.City)),
    ]),
    _c("div", [_vm._v(_vm._s(_vm.party.CountryCode))]),
    _vm.party.VATNumber
      ? _c("div", { staticClass: "party-vat" }, [
          _vm._v(_vm._s(_vm.party.VATNumber)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }